export const TOOLS = [
  {
    id: "move-counter",
    title: "Лічильник ходів",
    blocks: [
      {
        t: "p",
        c: "Вставте своє рішення у звичайному запису (`U D F B L R`, слайси `M E S`, ротації `x y z`), і воно порахує ходи за правилами кх. Частину в дужках `(...)` лічильник сприймає як **NISS** — рухи на іншому боці скрамблу, вони теж рахуються в загальну суму. Ротації не рахуються. Коментар після `//` ігнорується.",
      },
      {
        t: "note",
        tone: "tip",
        title: "Що перевіряє лічильник",
        c: "Позначає нерозпізнані ходи (наприклад, wide-рухи на кшталт `Rw` чи `r`, які в записі кх не використовують) і підказує, де сусідні ходи на ту саму грань варто скоротити (`R R` → `R2`, `R R'` — взаємно скорочуються).",
      },
    ],
  },
];
